import LogoWithLink from '@common/components/Logo/LogoWithLink';
import type { ReactNode } from 'react';

interface AuthStatusShellProps {
    children: ReactNode;
}

export function AuthStatusShell({ children }: AuthStatusShellProps) {
    return (
        <div className="flex h-screen w-full flex-col items-center justify-between bg-white">
            <div className="fixed left-8 top-8">
                <LogoWithLink size="26px" />
            </div>

            <div className="flex h-full w-full items-center justify-center">
                {children}
            </div>
        </div>
    );
}

interface AuthStatusPanelProps {
    children: ReactNode;
}

export function AuthStatusPanel({ children }: AuthStatusPanelProps) {
    return (
        <main className="flex max-w-md flex-col items-center gap-6 p-12 text-center">
            {children}

            <div className="mt-4 w-full max-w-md border-t border-gray-200 pt-6">
                <p className="m-0 text-sm text-gray-400">
                    Need help? Contact our support team
                </p>
            </div>
        </main>
    );
}
